import { Outlet } from 'react-router'

const AffiliatePrograms = () => {
	return <Outlet>Affiliate Programs view ,available</Outlet>
}
export default AffiliatePrograms
